import { Discount, PriceUtils, Product, ProductChoice } from "@repo/common"
import * as React from "react"

interface PriceCalculationData {
  laborPrice?: number
  laborPriceDiscount?: Discount | null
  products: Product[]
  productChoices: ProductChoice[]
  productDecisions?: Record<string, string>
}

/**
 * Returns the action's discounted `total` (the headline price) plus the
 * pre-discount `rawTotal` used to render the strike-through "before
 * discount" label next to it.
 */
export function useTotalActionPrice(data: PriceCalculationData) {
  return React.useMemo(
    () =>
      PriceUtils.calculateActionTotalCost({
        laborPrice: data.laborPrice,
        laborPriceDiscount: data.laborPriceDiscount,
        products: data.products,
        productChoices: data.productChoices,
        productDecisions: data.productDecisions,
      }),
    [
      data.laborPrice,
      data.laborPriceDiscount,
      data.products,
      data.productChoices,
      data.productDecisions,
    ],
  )
}
